import { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { useCookieConsent } from '@/lib/hooks/useCookieConsent'
import { Button } from '@/components/ui/button'

export function ConsentNotice() {
  const { hasConsented, acceptAll, acceptFunctional, rejectAll } = useCookieConsent()
  const [isVisible, setIsVisible] = useState(!hasConsented)

  const handleAcceptAll = () => {
    acceptAll()
    setIsVisible(false)
  }

  const handleAcceptFunctional = () => {
    acceptFunctional()
    setIsVisible(false)
  }

  const handleRejectAll = () => {
    rejectAll()
    setIsVisible(false)
  }

  if (!isVisible) {
    return null
  }

  return (
    <AnimatePresence>
      <motion.div
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 100, opacity: 0 }}
        transition={{ duration: 0.3 }}
        className="fixed bottom-0 left-0 right-0 z-50 p-4 sm:p-6"
      >
        <div className="max-w-5xl mx-auto bg-card border-2 border-border rounded-xl shadow-2xl p-6">
          <div className="flex flex-col gap-4">
            <div>
              <h2 className="text-lg font-semibold mb-2">Cookie Settings</h2>
              <p className="text-sm text-muted-foreground mb-3">
                We use essential cookies for authentication and security. We'd also like to:
              </p>
              <ul className="text-sm text-muted-foreground space-y-1 mb-3">
                <li>• Save your theme preference (dark/light mode)</li>
                <li>
                  • Collect anonymous usage statistics via Google Analytics to improve our platform
                </li>
              </ul>
              <p className="text-xs text-muted-foreground">
                You can manage your preferences anytime. See our{' '}
                <a href="/cookies" className="underline hover:text-foreground transition-colors">
                  Cookie Policy
                </a>{' '}
                for details.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
              <Button
                onClick={handleAcceptAll}
                size="lg"
                className="font-semibold flex-1 sm:flex-initial"
              >
                Accept All
              </Button>

              <Button
                onClick={handleAcceptFunctional}
                variant="outline"
                size="lg"
                className="font-semibold flex-1 sm:flex-initial"
              >
                Functional Only
              </Button>

              <Button
                onClick={handleRejectAll}
                variant="ghost"
                size="lg"
                className="font-semibold flex-1 sm:flex-initial"
              >
                Essential Only
              </Button>
            </div>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  )
}
